import {isNotEmpty} from '@doltech/utils/lib/text';
import {isNil, range} from 'lodash';
import {Instance, types as t} from 'mobx-state-tree';

import {
  DiagramLabelCompletion,
} from '../../../question-data-model/Question/_implementations/diagram-label-completion.store';
import {BlankUserAnswerInstance} from '../../../question-data-model/Question/Blank/blank-user-answer.store';
import {TestQuestionStore} from '../test-question.store';
import {AnswerQuestionInput} from './abstract-do-test-question-with-blanks.store';

const isAnswered = (answer: BlankUserAnswerInstance) => {
  return answer && isNotEmpty(answer.userAnswer);
};

export const DoTestDiagramLabelCompletionQuestion = t
  .compose(TestQuestionStore, DiagramLabelCompletion)
  .named('DoTestDiagramLabelCompletionQuestion')
  .views((self) => ({
    get groupName() {
      return 'Diagram Label Completion';
    },

    get formattedQuestionNo() {
      return self.no;
    },

    get bottomBarQuestionNoes() {
      return range(self.getBlanksFromNodeBlanks().length)
        .map((noIndex) => {
          const no = self.no + noIndex;
          return {
            no,
            answered: isAnswered(
              self.userAnswers.find((_u, userAnswerIndex) => userAnswerIndex === noIndex)
            ),
          };
        })
        .filter((item) => Boolean(item));
    },

    get questionCount() {
      return self.getBlanksFromNodeBlanks().length;
    },

    get answerCount() {
      return self.userAnswers.filter((o) => isAnswered(o)).length;
    },
    get allUserAnswers() {
      return self.userAnswers.map((ua) => {
        return {
          ...ua,
          text: ua.userAnswer,
        };
      });
    },

    prepareDataForSubmit() {
      return {
        questionId: self.uuid,
        type: self.type as any,
        userAnswers: self.userAnswers,
      };
    },
  }))
  .actions((self) => ({
    initUserAnswers() {
      self.userAnswers.replace(
        self.getBlanksFromNodeBlanks().map((nodeBlank, index) => {
          const userAnswer = self.userAnswers.find((_ua, uaIndex) => uaIndex === index);
          if (isNil(userAnswer)) {
            return {
              blankId: nodeBlank.blankId,
              userAnswer: '',
            };
          }
          return userAnswer;
        })
      );
    },
    onAnswerQuestion(input: AnswerQuestionInput) {
      const { blankId, text } = input;
      const existedUserAnswer = self.userAnswers.find((userAnswer) => {
        return userAnswer.blankId === blankId;
      });
      if (existedUserAnswer) {
        existedUserAnswer.userAnswer = text;
      }
    },
  }));

export interface DoTestDiagramLabelCompletionQuestionInstance
  extends Instance<typeof DoTestDiagramLabelCompletionQuestion> {}
